/**
 * 获取价格最小变动单位
 * @param {number} price - 价格
 * @param {array} minTicks - 价格最小变动区间
 *
 * @returns {number}
 */
export default function getPriceMinTick(price, minTicks, defaultMinTick = 0) {
  price = Number(price)
  if (Number.isNaN(price) || !minTicks || !minTicks.length) {
    return defaultMinTick
  }
  for (let i = 0; i < minTicks.length; i++) {
    const tick = minTicks[i]
    if (price >= tick.begin && price < tick.end) {
      return tick.tickSize || tick.minTick
    }
  }
  return defaultMinTick
}
